import { render, staticRenderFns } from "./MarketWinLose.vue?vue&type=template&id=18b01c76&scoped=true&"
import script from "./MarketWinLose.vue?vue&type=script&lang=js&"
export * from "./MarketWinLose.vue?vue&type=script&lang=js&"
import style0 from "./MarketWinLose.vue?vue&type=style&index=0&id=18b01c76&lang=scss&scoped=true&"
import style1 from "./MarketWinLose.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b01c76",
  null
  
)

export default component.exports